module.exports = window.fetch;